// extracted by css-extract-rspack-plugin
export default {"Summary":"dyrDa7QWJjsOzCQi","Marker":"r3CdCZ7BAeYLRju3"};